export const EventTypes = {
    DeviceInfoUpdate: 'device-info-update',
    DeviceLocationHistoryInsert: 'location-history-insert',
    JoinRoom: 'join-room',
    LeaveRoom: 'leave-room',
    RoomConnect: 'room-connect',
    RoomConnectError: 'room-connect_error',
    RoomDisconnect: 'room-disconnect',
    RoomDisconnectError: 'room-disconnect_error',
};
